/** parsePriorityFilters produce a filter object (see example) populated
 * from the given URLSearchParams object. */
export const parsePriorityFilters = (params /* URLSearchParams */) => ({
  // Filters
  active_for_astrosite: params.get("active_for_astrosite"),
  priority_ids: params.get("priority_ids"), // id is in this list
  name_ctns: params.get("name_ctns"), // list name contains this string somewhere
  object_id: params.get("object_id"), // the list has this object
  sort_order: params.get("sort_order") || "DESC", // The sort order
  sort_by: params.get("sort_by") || "from", // The column to sort by
})
